import React from 'react'
import Callback from "./Callback";
import Clients from "./Clients";
import { Experience } from "./Experience";
import { Feature } from "./Feature";
import Footer from "./Footer";
import Hero from "./Hero";
import OfficeLocations from "./OfficeLocations";
import Service from "./Service";
import Stack from "./Stack";
import Helmet from "react-helmet";
import VirtueTechLogo from '../assets/Favicon.png';
import HeroSection from './Hero';
import About from './About';
// import Clientttttt from './Clientttttt';
import ContactForm from './ContactForm';
import Project from './Project';
import HeaderSmallWithStyles from './HeaderSmall';
import HeaderWithStyles from './Header';
import SideNavigation from './ui/SideNavigation';
import Clientttttt from './ui/NewClient';
import Blogs from './blogs';
import ClienttttttWithFooter from './ui/NewClient';
import { GSAPAnimations } from './GSAPAnimations';

import { useOutletContext } from 'react-router-dom';


const PageLayout = () => {
  const { isMenuOpen } = useOutletContext();

  const footer = {
    ftitle: "Digital presence to the next level?",
    desc: "Reach out to us today and let's discuss how we can help you achieve your goals."
  }

  const handleScroll = () => {
    const aboutSection = document.getElementById("About");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main className="relative max-w-8xl lg:px-32 px-5 bg-white dark:bg-black flex justify-center items-center flex-col overflow-hidden mx-auto">
      {/* Side Navigation */}
      <SideNavigation isMenuOpen={isMenuOpen} />
      <GSAPAnimations />

      <div className="w-full">
        <Helmet>
          <title>Vivek Khule - Professional Frontend Developer</title>
          <meta name="description" content="Vivek Khule is a skilled React frontend developer with expertise in creating seamless user interfaces and dynamic web applications. Let's bring your ideas to life!" />
          <meta name="keywords" content="Vivek Khule, React developer, frontend developer, JavaScript, web development, UI/UX, responsive design, web applications, portfolio" />
          <meta property="og:title" content="Vivek Khule - Professional Frontend Developer" />
          <meta property="og:description" content="Vivek Khule is a skilled React frontend developer with expertise in creating seamless user interfaces and dynamic web applications. Let's bring your ideas to life!" />
          <meta property="og:image" content="path-to-your-logo-or-image.jpg" />
          <meta property="og:url" content="https://vivekkhule.dev/" />
          <meta name="twitter:title" content="Vivek Khule - Professional Frontend Developer" />
          <meta name="twitter:description" content="Vivek Khule is a skilled React frontend developer with expertise in creating seamless user interfaces and dynamic web applications. Let's bring your ideas to life!" />
          <meta name="twitter:image" content="path-to-your-logo-or-image.jpg" />
          <link rel="canonical" href="https://vivekkhule.dev/" />

        </Helmet>

        <div className='w-full relative'>
          <HeroSection />
          <div id="arrow" className='dark:border-zinc-100 md:block hidden border bg-transparent border-zinc-900 dark:hover:bg-zinc-100 hover:bg-zinc-900 z-30' onClick={handleScroll}>
            <i className="ri-arrow-down-line dark:text-zinc-100 text-zinc-900 dark:hover:text-zinc-900 hover:text-zinc-900"></i>
          </div>

        </div>

        <div id="insights">
          <Feature />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="works">
          <Experience />
        </div>
        <div id="projects">
          <Project />
        </div>
        <div id="stack">
          <Stack />
        </div>
        <div id="testimonials">
          <ClienttttttWithFooter />
        </div>
        {/* <div id="contact">
          <ContactForm />
        </div> */}

        {/* <Blogs /> */}

      </div>
    </main>
  )
}

export default PageLayout;
